<div id="modalError" class="modal-background" [class.show]="show">
  <div class="modal-container">
    <div class="modal-content">
      <span *ngIf="closeButton" (click)="onClose()" class="close">&times;</span>
      <div class="modal-body">
        <img
          class="modal-icon"
          [src]="icon"
          width="60"
          height="60"
          alt="Modal icon"
        />

        <p class="modal-title">{{ title }}</p>
        <p class="modal-message" [innerHTML]="message"></p>
      </div>

      <div class="modal-actions">
        <button class="modal-close-button" (click)="onClose()" *ngIf="closeButton">
          Cerrar
        </button>
        <button class="modal-button" (click)="onPrimaryAction()">
          {{ actionLabel }}
        </button>
      </div>
    </div>
  </div>
</div>
